import { calculateAbweichung } from '@/utils/helperFunctions';
import { ArbeitsbereichCellContent } from '../cells/ArbeitsbereichCell';
import {
  ArbeitszeitCellArbeitszeitContent,
  ArbeitszeitCellContentAbwesenheit,
} from '../cells/ArbeitszeitCell';
import { KonfliktWrapper } from '../cells/KonfliktWrapper';
import { MitarbeiterContent } from '../cells/MitarbeiterCell';
import { RowTypeMap } from '../entities/Entities';
import { CellRenderers } from './renderer';
import { DauerCellContent } from '../cells/DauerCell';
import { HinweiseCellContent } from '../cells/HinweiseCell';
import { Abwesenheit } from '../entities/Abwesenheit';
import { Arbeitszeit } from '../entities/Arbeitszeit';

import { KonfliktActionWrapper } from '@/domain/arbeitszeiten/components/Table/ToDoTable/cells/KonfliktActionCellWrapper';

const konfliktRenderer: CellRenderers<RowTypeMap['konflikt']> = {
  name: (row) => (
    <KonfliktWrapper
      root={
        <MitarbeiterContent mitarbeiter={row.rootArbeitszeit.mitarbeiter} />
      }
      cause={
        row.conflictCause !== null ? (
          <MitarbeiterContent mitarbeiter={row.rootArbeitszeit.mitarbeiter} />
        ) : null
      }
    />
  ),
  arbeitsbereich: (row) => (
    <KonfliktWrapper
      root={
        <ArbeitsbereichCellContent
          arbeitsbereich={row.rootArbeitszeit.arbeitsbereich}
        />
      }
      cause={
        row.conflictCause !== null ? (
          <ArbeitsbereichCellContent
            arbeitsbereich={row.conflictCause.arbeitsbereich}
          />
        ) : null
      }
    />
  ),
  arbeitszeit: (row) => (
    <KonfliktWrapper
      root={
        <ArbeitszeitCellArbeitszeitContent
          beginn={row.rootArbeitszeit.beginn}
          kommen={row.rootArbeitszeit.kommen}
          ende={row.rootArbeitszeit.ende}
          gehen={row.rootArbeitszeit.gehen}
          pausenDauer={row.rootArbeitszeit.getPausendauer()}
          id={row.rootArbeitszeit.id}
          pausen={row.rootArbeitszeit.pausen}
        />
      }
      cause={
        row.conflictCause === null ? null : (
          <>
            {row.conflictCause instanceof Abwesenheit && (
              <ArbeitszeitCellContentAbwesenheit
                abwesenheit={row.conflictCause}
              />
            )}
            {row.conflictCause instanceof Arbeitszeit && (
              <ArbeitszeitCellArbeitszeitContent
                beginn={row.conflictCause.beginn}
                kommen={row.conflictCause.kommen}
                ende={row.conflictCause.ende}
                gehen={row.conflictCause.gehen}
                pausenDauer={row.conflictCause.getPausendauer()}
                id={row.conflictCause.id}
                pausen={row.conflictCause.pausen}
              />
            )}
          </>
        )
      }
    />
  ),
  dauer: (row) => {
    let abweichungRoot = undefined;
    if (row.rootArbeitszeit.beginn && row.rootArbeitszeit.ende) {
      abweichungRoot = calculateAbweichung(
        row.rootArbeitszeit.beginn.abweichung,
        row.rootArbeitszeit.ende.abweichung,
      );
    }

    return (
      <KonfliktWrapper
        cause={
          row.conflictCause !== null ? (
            <DauerCellContent dauer={row.conflictCause.dauer} />
          ) : null
        }
        root={
          <DauerCellContent
            dauer={row.rootArbeitszeit.dauer}
            abweichung={abweichungRoot}
          />
        }
      />
    );
  },
  hinweise: (row) => (
    <KonfliktWrapper
      root={
        <HinweiseCellContent
          rechtshinweise={row.rootArbeitszeit.rechtshinweise}
          zuschlaege={row.rootArbeitszeit.zuschlaege}
          termin={row.rootArbeitszeit.termin}
          bemerkung={row.rootArbeitszeit.bemerkung}
        />
      }
      cause={
        row.conflictCause === null ? null : (
          <>
            {row.conflictCause instanceof Arbeitszeit && (
              <HinweiseCellContent
                rechtshinweise={row.conflictCause.rechtshinweise}
                zuschlaege={row.conflictCause.zuschlaege}
                termin={row.conflictCause.termin}
                bemerkung={row.conflictCause.bemerkung}
              />
            )}
          </>
        )
      }
    />
  ),
  action: (row) => <KonfliktActionWrapper konflikt={row} />,
};

export default konfliktRenderer;
